import React, { useEffect } from "react";

const AppCustomerConsent: React.FC = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const requestId = params.get("request_id");

    if (requestId) {
      window.location.href = `moneymaxapproval://app-customer-consent-approval?request_id=${requestId}`;
    }
  }, []);

  return <>Redirecting customer pledge consent approval to the app...</>;
};

export default AppCustomerConsent;
